import React, { cloneElement, useMemo } from "react";
import { QuestionCircleFill } from "react-bootstrap-icons";
import { Tooltip, Whisper } from "rsuite";

export default function RATooltip({ children, tooltipElement = <QuestionCircleFill />, className = "", size = 20, style = {} }) {
    const tooltip = useMemo(() => <Tooltip arrow={false}>{children}</Tooltip>, [children]);
    const controlId = useMemo(() => Math.random().toString(36).substring(2, 10), []);

    // Apply the tooltipElement with additional className and style
    const customTooltipElement = cloneElement(tooltipElement, {
        className: `text-ra-yellow align-self-center ${className}`,
        style: { width: size, height: size, ...style },
    });

    return (
        <Whisper trigger="hover" placement="auto" speaker={tooltip} controlId={controlId}>
            {customTooltipElement}
        </Whisper>
    );
}
